module.exports = __webpack_public_path__ + "img/banner-bili.65c67afa.jpeg";